import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import qs from "qs";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 7,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  },
  grid: {
    width: "100%"
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 5,
    marginRight: theme.spacing.unit * 5,
    marginTop: theme.spacing.unit * 5
  }
});

class GarminData extends Component {
  state = {
    user: {}
  };

  async fetchGarminUserData() {
    const result = await fetch(`/garmin/api/userdata`, {
      mode: "cors",
      method: "GET"
    });

    const data = await result.json();

    if (data.success) {
      this.setState({ user: data.data });
    }
  }

  componentDidMount() {
    this.fetchGarminUserData();
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        {JSON.stringify(this.state.user)}
      </div>
    );
  }
}

GarminData.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(GarminData);
